export default __webpack_public_path__ + "static/media/coin-drop.f2f04543.mp3";